import React, { Component } from 'react';
import App from 'base-shell/lib';
import _config from './config';
import init from './config/init';
import "./style/main.css";
export default class Demo extends Component {
	render() {
		init();
		return <App config={_config} />;
	}
}
